
//import {Vue} from "vue-property-decorator";
//import Component from "vue-class-component";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
import { http } from "@/config/HttpClient";
import { DateTime } from "luxon";
import { useConsultorioStore } from '@/store/consultorioStore';
import { globalStore } from '@/store/globalStore';
import { consultorioService } from '@/services/ConsultorioService';
import { AxiosResponse } from "axios";

@Component({
	name: "FichaEndodoncia",
})

export default class FichaEndodoncia extends Vue {
	@Prop() paciente_id!: any
	@Prop() cita!: any
	@Prop() swEditar!: any
	@Prop() ficha_selected!: any
	private globalStore = globalStore();
	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();
	private tab: any = null;
	piezas = [];
	pieza_dental = null;
	antecedentes = '';
	estado_actual = '';
	fecha_finalizacion = ''
	valid = true;
	preguntas = [];
	cerrada = [];
	respuestas = []
	tipos_movilidad = ['Grado 1', 'Grado 2', 'Grado 3', 'Grado 4']
	tipos_limas = [
		'Sistema Hayflex CM (6 Limas)',
		'Sistema Hayflex EDM (3 Limas)',
		'Sistema Wave on gold (4 Limas)',
		'Sistema TRU ANATOMY (3 Limas)',
		'Sistema completo TRU ANATOMY (5 Limas)'
	]
	limas = []
	private fechaInicial = DateTime.now().toFormat("yyyy-MM-dd");
	get tratamientos(): any {
		return this.consultorioStore.tratamientos;
	}
	get loading(): boolean {
		return this.consultorioStore.loading;
	}
	get tipo_ficha(): any {
		let tipo = '';
		if (this.cita && this.cita.tratamiento_id == 18 || this.cita.tratamiento_id == 19) {
			tipo = 'ENDODONCIA'
		}
		return tipo;
	}
	mounted() {
		this.getPiezas();
		this.getPreguntasEndodoncia()
		this.getRespuestas();
	}


	async getPiezas() {
		await http.get('get-piezas').subscribe({
			next: (response: AxiosResponse) => {
				this.piezas = response.data;
			},
		})
	}
	async getPreguntasEndodoncia() {
		this.consultorioStore.loading = true;
		let data = {
			ficha: 'ENDODONCIA'
		}
		await http.get('get-preguntas-endodoncia', { params: data }).subscribe({
			next: (response: AxiosResponse) => {
				this.preguntas = response.data;
				this.consultorioStore.loading = false;
			},
		})
	}

	select_opciones(tipo: string, pregunta: string) {
		let opciones = []
		switch (tipo) {
			case 'CERRADA':
				opciones = this.cerrada
				break;

			default:
				break;
		}
		return opciones;
	}
	guardar() {
		if (!this.$refs.form.validate()) {
			Alert.warning(`Lene todos los campos obligatorios (*)`)
			return;
		}
		let data = {
			pieza_dental_id: this.pieza_dental,
			paciente_id: this.paciente_id,
			antecedentes: this.antecedentes,
			estado_actual: this.estado_actual,
			cita_id: this.cita.id,
			preguntas_x_clasificacion: this.preguntas,
			tipo_ficha: this.tipo_ficha,
			ficha_id: this.ficha_selected ? this.ficha_selected.id : null,
			limas: this.limas
		}
		if (!this.swEditar) {


			Alert.confirm(`Se realizará el registro de la ficha`, 'Registrar nueva Ficha?').then(async result => {
				if (result.isConfirmed) {
					await this.consultorioService.registrarFicha(data)

				}
			})
		} else {

			Alert.confirm(`Se realizará la modificacion de la ficha`, 'Modificar ficha?').then(async result => {
				if (result.isConfirmed) {
					await this.consultorioService.updateFicha(data)
				}
			})
		}

	}

	async cargarDatos() {
		if (this.swEditar) {
			this.pieza_dental = this.ficha_selected.pieza_dental_id;
			this.antecedentes = this.ficha_selected.antecedentes;
			this.estado_actual = this.ficha_selected.estado_actual;
			this.limas = JSON.parse(this.ficha_selected.limas);

			this.preguntas.forEach(element => {
				element.preguntas.forEach(el => {
					let respuesta = this.respuestas.find(val => val.pregunta_id == el.id)
					if (respuesta) {
						//console.log(respuesta)
						el.respuesta = respuesta.respuesta;
						el.observacion = respuesta.observacion
						console.log(el)
					}
				});
			});

		}
	}

	async getRespuestas() {
		await http.get(`get-respuestas-paciente/${this.paciente_id}`).subscribe({
			next: (response: AxiosResponse) => {
				this.respuestas = response.data;
				this.cargarDatos();
			},
		})
	}



}

